/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XmlProtocolResponseDto
 */
export interface XmlProtocolResponseDto {
    /**
     * XML protocol packet
     * @type {string}
     * @memberof XmlProtocolResponseDto
     */
    xml: string;
}

/**
 * Check if a given object implements the XmlProtocolResponseDto interface.
 */
export function instanceOfXmlProtocolResponseDto(value: object): value is XmlProtocolResponseDto {
    if (!('xml' in value) || value['xml'] === undefined) return false;
    return true;
}

export function XmlProtocolResponseDtoFromJSON(json: any): XmlProtocolResponseDto {
    return XmlProtocolResponseDtoFromJSONTyped(json, false);
}

export function XmlProtocolResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): XmlProtocolResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'xml': json['xml'],
    };
}

export function XmlProtocolResponseDtoToJSON(value?: XmlProtocolResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'xml': value['xml'],
    };
}

